import React from 'react';
import { Controller } from 'react-hook-form';

import FormErrorLabel from 'components/atoms/FormErrorLabel';
import { Checkbox, FormControlLabel } from '@mui/material';
import {
  defaultCheckboxStyle,
  StyledCheckboxBackgroundWrapper,
  StyledCheckboxLabel,
  StyledFormCheckboxWrapper,
} from 'components/molecules/FormCheckbox/styles';
import { IFormElementProps } from 'models/form';

export const FormCheckbox = ({
  name,
  label,
  labelElement,
  control,
  errors,
  withValidation = true,
  disabled = false,
  onChange,
  style = defaultCheckboxStyle,
  labelVariant = 'body2',
}: IFormElementProps) => (
  <StyledFormCheckboxWrapper className="FormCheckbox">
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          {...field}
          control={
            <StyledCheckboxBackgroundWrapper backgroundColor={style?.backgroundColorUnChecked}>
              <Checkbox
                disabled={disabled}
                checked={field.value}
                sx={{
                  color: style.borderColor,
                  '&.Mui-checked': {
                    color: style.backgroundColorChecked,
                  },
                  '&.Mui-disabled': {
                    color: style.backgroundColorDisabled,
                  },
                }}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                  if (onChange) {
                    onChange(e.target.checked);
                  }
                }}
              />
            </StyledCheckboxBackgroundWrapper>
          }
          label={
            label !== undefined || labelElement !== undefined ? (
              <StyledCheckboxLabel disabled={disabled} variant={labelVariant || 'body2'}>
                {label ?? labelElement}
              </StyledCheckboxLabel>
            ) : (
              ''
            )
          }
        />
      )}
    />
    {withValidation && errors[name]?.message && (
      <FormErrorLabel label={errors[name]?.message} />
    )}
  </StyledFormCheckboxWrapper>
);
